import { getGroupFilesHubFREStore } from '../store/GroupFilesHubFREStore';
import { mutatorAction } from 'satcheljs';

export enum CalloutTarget {
    SP,
    RecentFiles,
}

export const setCalloutShown = mutatorAction('setCalloutShown', async function setCalloutShown(
    target: CalloutTarget
) {
    if (target === CalloutTarget.SP) {
        getGroupFilesHubFREStore().spCalloutShown = true;
    } else {
        // target === CalloutTarget.RecentFiles
        getGroupFilesHubFREStore().recentFilesCalloutShown = true;
    }
});
